import * as React from 'react';
import { styled } from '@linaria/react';

import useWindowDimensions from '@/hooks/use-window-dimensions';

interface Props {}

function Arrow({}: Props) {
  const windowDimensions = useWindowDimensions();

  const [path, setPath] = React.useState('');

  const svgRef = React.useRef<SVGSVGElement>(null);

  React.useEffect(() => {
    // Bail out if any elements are missing
    if (!svgRef.current) {
      return;
    }

    const svgBB = svgRef.current.getBoundingClientRect();

    const ARROW_WIDTH = 10;
    const ARROW_HEIGHT = 8;

    const startPoint = {
      x: 0,
      y: svgBB.height / 2,
    };

    // So our SVG is floating somewhere in the viewport. So is the
    // choice. Because SVGs use an internal coordinate system, I
    // need to figure out the choice's `y` coordinate by getting
    // the choice's bounding box relative to the SVG
    const endPoint = {
      x: svgBB.width - ARROW_WIDTH,
      y: svgBB.height / 2,
    };

    const path = `
      M ${startPoint.x} ${startPoint.y}
      L ${endPoint.x} ${endPoint.y}
      L ${endPoint.x - 1} ${endPoint.y + ARROW_HEIGHT}
      L ${endPoint.x + ARROW_WIDTH} ${endPoint.y}
      L ${endPoint.x - 1} ${endPoint.y - ARROW_HEIGHT}
      L ${endPoint.x} ${endPoint.y}
    `;

    setPath(path);
  }, [windowDimensions.width]);

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      width="100%"
      height="100%"
      fill="none"
    >
      {path && <path d={path} />}
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  overflow: visible;

  path {
    stroke: var(--color-secondary);
    stroke-width: 3px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export default Arrow;
